import { useWatch } from "react-hook-form";


import SaveFormAddURL from "~/components/SaveForm/SaveForm.addLink";
import SaveFormEditLink from "~/components/SaveForm/SaveForm.editLink";
import SaveFormForm from "~/components/SaveForm/SaveForm.form";
import SaveFormSelectLocation from "~/components/SaveForm/SaveForm.selectLocation";
import { useSaveFormContext } from "~/components/SaveForm/shared";

export default function SaveFormStack() {
  const { control } = useSaveFormContext();

  const values = useWatch({ control });

  switch (values.type) {
    case "URL": {
      switch (values.step) {
        case "addUrl": {
          return <SaveFormAddURL />;
        }

        case "editUrl": {
          return <SaveFormEditLink />;
        }

        case "form": {
          return <SaveFormForm />;
        }

        case "selectLocation": {
          return <SaveFormSelectLocation />;
        }

        default:
          return null;
      }
    }

    case "MEDIA":
    case "FILE": {
      switch (values.step) {
        // TODO: This makes no sense. Refactor the SaveFormAddURL function _or_ have separate components
        case "showAsset": {
          return <SaveFormAddURL />;
        }

        case "form": {
          return <SaveFormForm />;
        }

        case "selectLocation": {
          return <SaveFormSelectLocation />;
        }

        default:
          return null;
      }
    }

    case "NOTE": {
      switch (values.step) {
        case "takeNote": {
          return <SaveFormAddURL />;
        }

        case "form": {
          return <SaveFormForm />;
        }

        case "selectLocation": {
          return <SaveFormSelectLocation />;
        }

        default:
          return null;
      }
    }

    default: {
      return null;
    }
  }
}
